import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Section } from "@/components/UI";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { ContactFormWithLead } from "../ContactForm/ContactFormWithLead";
import { bottomContactOpenedFormTestId } from "../ContactForm/constants";
import { useIsStickyContactForm } from "../hooks/useIsStickyContactForm";
export const BottomContactOpenedForm = () => {
    const isProject = useIsNewBuildProject();
    const isStickyContactForm = useIsStickyContactForm();
    const { t } = useI18n();
    if (isStickyContactForm)
        return;
    return (_jsx(_Fragment, { children: _jsx(Section, { unsafeClassname: "HideOnPrint", children: _jsxs(Box, { boxShadow: "shadow.4", testId: bottomContactOpenedFormTestId, backgroundColor: "color.background.constant.white", borderRadius: "radius.16", width: "100%", paddingVertical: {
                    "breakpoint.base": "spacing.16",
                    "breakpoint.sm": "spacing.32",
                }, paddingHorizontal: {
                    "breakpoint.base": "spacing.16",
                    "breakpoint.sm": "spacing.80",
                    "breakpoint.lg": "spacing.80",
                }, children: [_jsxs(Box, { textAlign: "center", typography: "typography.headline.24.bold", color: "color.content.default.default", marginBottom: "spacing.24", children: [_jsx(Box, { as: "div", children: t("contact.bottom_cta.headline_one") }), _jsx(Box, { as: "div", children: isProject
                                    ? t("contact.bottom_cta.project.headline_two")
                                    : t("contact.bottom_cta.headline_two") })] }), _jsx(ContactFormWithLead, { av_zone: "middle", close: () => { } })] }) }) }));
};
